import { isNotNullOrUndefined, isNullOrUndefined } from 'Util/TypeGuards';
import { formatPriceDisplay } from 'Util/_HumanWritten/PriceFormattingUtils';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { IPriceLineItem } from 'Services/Api/_HumanWritten/PricingService/PricingResult';
import { ErrorCard } from 'Views/Components/_HumanWritten/ErrorCard/ErrorCard';
import { Button, Colors, Display } from 'Views/Components/Button/Button';
import If from 'Views/Components/If/If';
import { useBookingWizardDataStore } from '../../BookingWizardDataStore';
import { FreightBookingWizardData, validateFreightDetail } from '../../BookingWizardData/FreightBookingWizardData';
import { ScrollToError } from 'Validators/Functions/HumanWritten/ScrollToError';
import { appConfigStore } from 'Models/AppConfigStore';
import { FreightTypeDto } from 'Services/Api/_HumanWritten/BookingWizardDataService';

export interface ShipmentCalculationSectionProps {
	freightTypeDtos: FreightTypeDto[];
	priceLineItem?: IPriceLineItem;
	setPriceLineItem: React.Dispatch<React.SetStateAction<IPriceLineItem | undefined>>;
	setTriggerCalculation: React.Dispatch<React.SetStateAction<number>>;
}

export function ShipmentCalculationSection({
	freightTypeDtos,
	priceLineItem,
	setPriceLineItem,
	setTriggerCalculation,
}: ShipmentCalculationSectionProps) {
	const [incompleteFormError, setIncompleteFormError] = useState(false);
	const intl = useIntl();

	const { wizardData, setInnerWizardErrors } = useBookingWizardDataStore();

	useEffect(() => {
		setIncompleteFormError(false);
	}, [wizardData.innerWizardData]);

	return (
		<div className="shipment-details-calculation__container">
			<Button
				display={Display.Outline}
				colors={Colors.Black}
				onClick={() => {
					const validateFreightDetailContext = {
						freightTypeDtos,
						freightDimensionsHiddenOnStaticPriceEnabled:
							appConfigStore.freightDimensionsHiddenOnStaticPriceEnabled,
					};
					const errors = validateFreightDetail(
						wizardData.innerWizardData as FreightBookingWizardData,
						validateFreightDetailContext,
					);
					if (Object.keys(errors).length === 0 && Object.keys(errors).length === 0) {
						setTriggerCalculation(prev => prev + 1);
					} else {
						setIncompleteFormError(true);
						ScrollToError();
						setInnerWizardErrors(errors);
						setPriceLineItem(undefined);
					}
				}}
			>
				{isNullOrUndefined(priceLineItem) || incompleteFormError
					? 'Calculate shipment'
					: 'Re-calculate shipment'}
			</Button>
			<If condition={incompleteFormError}>
				<ErrorCard
					className=""
					title={intl.formatMessage({
						id: 'freight-booking-wizard__shipment-tab__incomplete-error__title',
						defaultMessage: 'Incomplete shipment details',
					})}
					subtitle={intl.formatMessage({
						id: 'freight-booking-wizard__shipment-tab__incomplete-error__subtitle',
						defaultMessage: 'Please complete the shipment details before calculating the shipment cost.',
					})}
				/>
			</If>
			<If condition={isNotNullOrUndefined(priceLineItem) && incompleteFormError === false}>
				<div className="shipment-details__calculation">
					<h4>
						<FormattedMessage
							id="freight-booking-wizard__shipment-tab__shipment-cost__heading"
							defaultMessage="Shipment cost"
						/>
					</h4>
					<h2>
						{formatPriceDisplay(
							priceLineItem?.price ?? 0,
							wizardData.wizardMode === 'ALTERATION',
							true,
							false,
						)}
					</h2>
					<p>{priceLineItem?.description ?? ''}</p>
				</div>
			</If>
		</div>
	);
}
